import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

export default function UpdateCdd() {
  const [search, setSearch] = useState("");

  const [cddList, setCddList] = useState([]);
  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();
 


  /* =========================
     FETCH ALL CDD
  ========================= */
  const fetchCDD = async () => {
    try {
      const res = await axios.get("https://irc.zentelex.com/api/cdd-receipts/all", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCddList(res.data.data || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch CDD data", "error");
    }
  };

  useEffect(() => {
    fetchCDD();
  }, []);

   const handleEdit = (item) => {
  navigate(`/commodity-delivery-document/edit/${item.id}`);
};

  const filteredCddList = cddList.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.cddNo?.toLowerCase().includes(text) ||
      item.documentDate?.toLowerCase().includes(text) ||
      item.clientName?.toLowerCase().includes(text) ||
      item.commodityName?.toLowerCase().includes(text) ||
      item.warehouseName?.toLowerCase().includes(text)
    );
  });

  return (
    <div className="container mt-4">
      <div className="card shadow border-0">
        <div className="card-header bg-Success text-white">
          <h4 className="mb-0">Update Commodity Delivery Document</h4>
        </div>
        <br />

        <div className="mb-3">
          <input
            type="text"
            className="form-control border-primary"
            placeholder="🔍 Search CDD / Client / Commodity / Warehouse..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <br />

        <div className="card-body table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>CDD No</th>
                <th>Date</th>
                <th>Client</th>
                <th>Commodity</th>
                <th>Warehouse</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredCddList.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Records Found
                  </td>
                </tr>
              ) : (
               filteredCddList.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.cddNo}</td>
                    <td>{item.documentDate}</td>
                    <td>{item.clientName}</td>
                    <td>{item.commodityName}</td>
                    <td>{item.warehouseName}</td>

                    <td>
                   
                    <button
                     className="btn btn-primary btn-sm"
                     onClick={() => handleEdit(item)}
                     >
                    ✏️ Update
                   </button>

		   </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
